import { combineReducers } from 'redux'
import authReducer from './authReducer'
import dashboardReducer from './dashboardReducer'
import lifeReducer from './lifeReducer'
import glucoseReducer from './glucoseReducer'
import userReducer from './userReducer'
import navBarReducer from './navBarReducer'
import notificationReducer from './notificationReducer'
import reportReducer from './reportReducer'
import shortcutReducer from './shortcutReducer'

const reducers = combineReducers({
    auth: authReducer,
    dashboards: dashboardReducer,
    lives: lifeReducer,
    glucose: glucoseReducer,
    users: userReducer,
    navBar: navBarReducer,
    notifications: notificationReducer,
    reports: reportReducer,
    shortcuts: shortcutReducer,
})

export default reducers

export type State = ReturnType<typeof reducers>